<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="cast"> </p>
<p class="h1"><span class="epub-b">CAST</span></p>
<p class="s"><span class="epub-sc">GEORGE</span>, male, 40s.</p>
<p class="s"><span class="epub-sc">FIONA</span>, female, 40s.</p>
<p class="s"><span class="epub-sc">ANNA</span>, female, 15. Anna is considerably overweight.</p>
<p class="s"><span class="epub-sc">TERRY</span>, male, 20s.</p>
<p class="stni">Ellipses following a character’s name indicate a desire to speak but an inability to know quite what to say.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cast-list.vue?66646d72